import { render, staticRenderFns } from "./BackLinkButton.vue?vue&type=template&id=4a246f45"
import script from "./BackLinkButton.vue?vue&type=script&lang=js"
export * from "./BackLinkButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports